import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Wrench, Droplets, Sparkles, Paintbrush, Store } from 'lucide-react';
const modules = [{
  icon: BookOpen,
  title: 'Módulo 1 — Introducción al Cemento & Yeso Deco',
  desc: 'Entendé qué podés crear, qué materiales existen y cómo empezar sin experiencia.'
}, {
  icon: Wrench,
  title: 'Módulo 2 — Materiales, herramientas y espacio de trabajo',
  desc: 'Conocé qué comprar, qué usar, qué evitar y cómo preparar tu espacio en casa.'
}, {
  icon: Droplets,
  title: 'Módulo 3 — Cemento desde cero',
  desc: 'Aprendé mezcla, proporciones, moldes, secado, desmolde, lijado y primeras piezas.'
}, {
  icon: Sparkles,
  title: 'Módulo 4 — Yeso desde cero',
  desc: 'Creá piezas delicadas, prolijas y vendibles para deco, regalos y souvenirs.'
}, {
  icon: Paintbrush,
  title: 'Módulo 5 — Terminaciones profesionales',
  desc: 'Pintura, color, sellado, efecto mármol, terrazo, detalles dorados y estilo premium.'
}, {
  icon: Store,
  title: 'Módulo 6 — Piezas listas para vender',
  desc: 'Costos, precios, combos, presentación, fotos, Instagram, WhatsApp y pedidos personalizados.'
}];
export function GuideContents() {
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-69">
      <div className="text-center mb-8 sm:mb-10" data-id="element-70">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-71">
          Todo lo que incluye la Mega Guía
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium max-w-2xl mx-auto" data-id="element-72">
          Un recorrido simple y ordenado para aprender desde cero y avanzar
          hasta crear productos listos para vender.
        </p>
      </div>

      <div className="space-y-4 sm:space-y-6" data-id="element-73">
        {modules.map((mod, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-deco-card rounded-2xl p-5 sm:p-6 border border-deco-warm shadow-sm flex items-start gap-4 sm:gap-6 hover:shadow-md transition-shadow" data-id="element-74">
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-deco-bg flex items-center justify-center shrink-0 text-deco-terra border border-deco-warm" data-id="element-75">
              <mod.icon size={24} className="sm:w-6 sm:h-6" data-id="element-76" />
            </div>
            <div data-id="element-77">
              <h3 className="text-lg sm:text-xl font-serif font-bold text-deco-text mb-1 sm:mb-2" data-id="element-78">
                {mod.title}
              </h3>
              <p className="text-deco-text/80 text-sm sm:text-base leading-relaxed" data-id="element-79">
                {mod.desc}
              </p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}